import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import { Button, ButtonSet } from '../../../core/components/styled'
import { ButtonLink, Input } from '../../../core/components'

const ChangePasswordForm = ({ handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <Field
      name="currentPassword"
      label="Current password"
      type="password"
      component={Input}
    />
    <Field name="password" label="Password" type="password" component={Input} />
    <Field
      name="confirmedPassword"
      label="Confirm password"
      type="password"
      component={Input}
    />

    <ButtonSet margin="medium no small">
      <Button type="submit" fluid color="primary" margin="no no xSmall">
        Change password
      </Button>

      <Button type="button" as={ButtonLink} to="/" fluid line color="primary">
        Cancel
      </Button>
    </ButtonSet>
  </form>
)

ChangePasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
}

export default ChangePasswordForm
